import Form from '../_form';
import Popup from '../../components/popup';

export default class ProfileContactForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const popup = new Popup({
            popup: '.site-popup[data-popup="profile-contact"]',
            toggle: '#profile-contact-trigger',
            close: '.site-popup-close[data-popup="profile-contact"]',
            window: '.site-popup-window[data-popup="profile-contact"]'
        });

        this.form.querySelector('button[type="reset"]').addEventListener('click', (event) => {
            event.stopPropagation();

            popup.close.click();
        });
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const id = formData.get('contact_user_id');

        const fullname = formData.get('fullname');
        const email = formData.get('email');
        const message = formData.get('message');

        try {
            await fetch('/wp-json/user/v1/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id, fullname, email, message })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Message sent!', data.message);

                    this.form.querySelector('button[type="reset"]').click();

                    if (this.submit) this.submit.classList.remove('preload');
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
